import { CHICLET_LIST, DEFAULT_SPINNER_HEIGHT, TEXT_LIST } from '../../constants/LoadingComponentProps';
import { getTextListSkeletonHeight } from './TextListSkeleton';
import { getChicletListSkeletonHeight } from './ChicletListSkeleton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function getMinHeightFromConfig(loadingComponentProps) {
  if (loadingComponentProps.type === TEXT_LIST) {
    return getTextListSkeletonHeight(loadingComponentProps);
  }
  if (loadingComponentProps.type === CHICLET_LIST) {
    return getChicletListSkeletonHeight(loadingComponentProps);
  }
  return loadingComponentProps.minHeight || DEFAULT_SPINNER_HEIGHT;
}
export default function CardContentPlaceholderDiv({
  cardId,
  loadingComponentProps
}) {
  const minHeight = loadingComponentProps.reduce((acc, props) => acc + getMinHeightFromConfig(props), 0);
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    "data-test-id": `${cardId}-loading`,
    minBlockSize: `${minHeight}px`
    // Same styles when grow = true on UILoadingSpinner
    ,
    blockSize: "100%",
    inlineSize: "100%"
  });
}